import React from 'react';
import { Card, Step, StepLabel, Stepper } from '@mui/material';

// Default headers
export default function StepProgressBar({ headers = [], rank = 0 }) {
  return (
    <Card sx={{ width: '100%', padding: 2}}>
      <Stepper activeStep={rank} alternativeLabel sx={{paddingTop: 4}}>
        {headers.map((label, index) => (
          <Step key={label} completed={rank > index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Card>
  );
}



